import D2C_TariffBusiness from './Business'

class D2C_TariffBusinessAnnual extends D2C_TariffBusiness {
  isAnnual = true
  static objectType = 'tariffType'
  static tariffId = '5b6d7de1bf716b8b96221800'
  static tariffTitle = 'Business annual'
  static order = 45
}

export default D2C_TariffBusinessAnnual
